<script>
	import Gallery from '../../Stores/Gallery';
	import Helper from '../../Classes/Helper';
	import Layout from '../../Stores/Layout';
	import Menu from '../../Stores/Menu';
	import Product from '../../Stores/Product';

	let editor = {};

	async function paint(texture, option) {
		try {
			for (let item of texture.options) item.active = false;
			option.active = true;

			const id = texture.id;
			const image = Helper.image(option.path);

			if (!Helper.is($Product.config.renderer)) $Product.config.renderer = {};
			$Product.config.renderer[id] = image;

			await window.renderer.texture(id, image);
			Gallery.render();
		}
		catch (exception)
			{ console.error(exception); }
	}

</script>

<style>
	div.zes-editor-info {
		line-height: 1.5em;
	}

	div.zes-editor-info > div:not(.zes-thumbnail) {
		margin-bottom: 2em;
	}

	div.zes-editor-info > div h4:first-child {
		margin-top: 0;
	}

	div.zes-editor-info > div h4 {
		padding-bottom: .5em;
		border-bottom: 1px solid hsl(0deg 0% 90%);
	}

	div.zes-editor-info > div h4 i {
		opacity: .5;
		margin-right: .4em;
	}

	/* Paint */

	div.zes-colors {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(7em, 1fr));
		gap: .65em;
		margin-bottom: 1.5em;
	}

	div.zes-colors div.zes-image {
		text-align: center;
		position: relative;
		padding: .25em;
		border: 1px solid hsl(0deg 0% 0% / .2);
		border-radius: .3em;
		cursor: pointer;
	}

	div.zes-colors div.zes-image:hover {
		border-color: var(--zes-1-3);
	}

	div.zes-colors div.zes-image.zes-active {
		border-color: var(--zes-1-3);
		box-shadow: 0 0 .5em 0 var(--zes-1-3);
		background: #FFF;
		z-index: 5;
		animation: colorActive 1s ease-in-out;
	}

	div.zes-colors div.zes-image div {
		font-size: .75em;
		font-weight: 600;
		text-shadow: 1px 1px 0 hsl(0deg 0% 0% / .5);
		color: hsl(0deg 100% 100%);
		width: 100%;
		height: 100%;
		padding: 1.5em 0;
		border-radius: .3em;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	div.zes-colors div.zes-image div span {
		font-weight: normal;
		font-size: .9em;
    	margin-top: .5em;
	}

	div.zes-colors div.zes-image div span:empty {
		display: none;
	}

	@keyframes colorActive {
		0% { transform: scale(1); }
		50% { transform: scale(1.75); }
		100% { transform: scale(1); }
	}
</style>

<div bind:this="{editor}" class="zes-editor-info">
	{#if Helper.is($Product.id)}
		<div class="zes-paint">
			{#each $Product.render_texture as texture}
				<h4><i class="fa-regular fa-fill-drip"></i> {texture.name}</h4>
				<div class="zes-colors">
					{#each texture.options as option}
						<div on:click="{event => paint(texture, option)}" class="zes-image" class:zes-active="{option.active}">
							<div style="background-image: url('{Helper.image(option.path)}')">
								{option.name}
							</div>
						</div>
					{/each}
				</div>
			{/each}
		</div>
	{/if}
</div>